import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { EmptyState, LoadingState, ErrorState } from "../../components/shared/EmptyState";
import { adminNav } from "../../components/shared/navConfig";
import { useApi, fmtDate } from "../../lib/useApi";

const STATUSES = ["", "Submitted", "Under Review", "Shortlisted", "Allocated", "Rejected", "Completed"];

export default function AdminApplications() {
  const [status, setStatus] = useState("");
  const { data, loading, error, reload } = useApi("/admin/applications", status ? { status } : undefined);
  const rows = data || [];
  return (
    <DashboardShell nav={adminNav} title="Applications" subtitle={data ? `${rows.length} applications` : "All student applications"}>
      <div className="flex gap-2 mb-4 flex-wrap">
        {STATUSES.map(s => (
          <button key={s || "all"} data-testid={`apps-filter-${(s || "all").replace(/\s/g, "-").toLowerCase()}`} onClick={() => setStatus(s)}
                  className={`text-xs px-3 py-1.5 rounded-full border transition-colors duration-200 ${status === s ? "border-blue-500/40 bg-blue-500/10 text-blue-500" : ""}`}
                  style={status === s ? {} : { borderColor: "var(--border-strong)", color: "var(--text-muted)" }}>{s || "All"}</button>
        ))}
      </div>
      <div className="card-surface p-4 sm:p-5">
        {loading ? <LoadingState/> : error ? <ErrorState message={error} onRetry={reload}/> : !rows.length ? (
          <EmptyState icon={FileText} title="No applications" desc="Applications appear here when verified students apply to live tasks." testId="apps-empty"/>
        ) : (
          <table className="table-stack w-full text-sm">
            <thead><tr className="text-[10px] uppercase tracking-widest text-left" style={{ color: "var(--text-dim)" }}>
              <th className="pb-3 font-normal">Student</th><th className="pb-3 font-normal">Task</th><th className="pb-3 font-normal">Match</th><th className="pb-3 font-normal">Applied</th><th className="pb-3 font-normal">Status</th><th className="pb-3 font-normal text-right">Action</th>
            </tr></thead>
            <tbody>
              {rows.map(a => (
                <tr key={a.application_id} data-testid={`app-row-${a.application_id}`} className="border-t" style={{ borderColor: "var(--border)" }}>
                  <td className="py-3"><div style={{ color: "var(--text)" }}>{a.student_name}</div><div className="text-[11px]" style={{ color: "var(--text-dim)" }}>{a.student_email}</div></td>
                  <td data-label="Task" className="text-xs" style={{ color: "var(--text-muted)" }}><span>{a.task_title || a.task_id} · {a.company_name || "—"}</span></td>
                  <td data-label="Match" className="text-xs font-mono" style={{ color: "var(--text)" }}><span>{a.match_score ?? "—"}%</span></td>
                  <td data-label="Applied" className="text-xs" style={{ color: "var(--text-muted)" }}><span>{fmtDate(a.applied_on)}</span></td>
                  <td data-label="Status"><StatusBadge status={a.status}/></td>
                  <td className="text-right stack-full"><div className="flex justify-end"><Link to={`/admin/allocation/${a.task_id}`} data-testid={`app-allocate-link-${a.application_id}`} className="btn-ghost px-3 py-2 rounded-full text-xs">Review & allocate</Link></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}
